import { gql } from '@apollo/client';

export const UPDATE_ENROLLMENT_STATUS = gql`
  mutation UpdateEnrollment($input: UpdateEnrollmentInput!) {
    updateEnrollment(input: $input) {
      id
      userId
      trainingId
      status
      enrolledAt
    }
  }
`;

// Example of the expected input format:
// {
//   id: 1,  # Must be a number, not a string
//   status: "APPROVED"  # Must be one of: PENDING, APPROVED, REJECTED, COMPLETED, CANCELLED
// }
